import React from 'react';
import { X, Copy, MapPin } from 'lucide-react';

interface LocationModalProps {
    lat: number;
    lng: number;
    accuracy?: number;
    onClose: () => void;
    onAddValve: () => void;
}

const LocationModal: React.FC<LocationModalProps> = ({ lat, lng, accuracy, onClose, onAddValve }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(`${lat}, ${lng}`);
        alert("Skopiowano do schowka!");
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{
                backgroundColor: 'white', padding: '24px', borderRadius: '12px',
                width: '350px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MapPin size={24} color="#3b82f6" /> Twoja Pozycja
                    </h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                        <X size={20} color="#666" />
                    </button>
                </div>

                <div style={{ backgroundColor: '#f3f4f6', padding: '16px', borderRadius: '8px', marginBottom: '20px' }}>
                    <div style={{ marginBottom: '8px' }}><strong>Lat:</strong> {lat.toFixed(8)}</div>
                    <div><strong>Lng:</strong> {lng.toFixed(8)}</div>
                    {accuracy && (
                        <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                            Dokładność GPS: ok. {Math.round(accuracy)} m
                        </div>
                    )}
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                        onClick={handleCopy}
                        style={{
                            flex: 1, padding: '10px', border: '1px solid #d1d5db',
                            backgroundColor: 'white', borderRadius: '8px', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontWeight: 600
                        }}
                    >
                        <Copy size={16} /> Kopiuj
                    </button>
                    <button
                        onClick={onAddValve}
                        style={{
                            flex: 1, padding: '10px', border: 'none',
                            backgroundColor: '#22c55e', color: 'white', borderRadius: '8px', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600
                        }}
                    >
                        + Postaw Zawór
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LocationModal;
